import { createContext, useContext } from 'react';

const FieldContext = createContext({});
FieldContext.displayName = 'FieldContext';

export const Provider = FieldContext.Provider;
export const Consumer = FieldContext.Consumer;
export const useField = () => useContext(FieldContext);
